import { useState } from 'react';
import {
    Box,
    FormControl,
    FormLabel,
    Stack,
    Text,
    VStack,
} from '@chakra-ui/react';
import { Field, useFormikContext } from 'formik';
import { Select } from 'chakra-react-select';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import {
    descriptionStyling,
    dropDownFormStyle,
    formLabelStyling,
    stackSpacing,
    stackStyling,
} from 'components/forms/new/formStyles';
import { ruleOptions } from '../consts';
import walkthroughIds from '../walkthroughIds';

const NONE_RULE_OPTION = { value: '', label: '— None' };
const allOptions = [NONE_RULE_OPTION, ...ruleOptions];

const RuleField = ({ darkMode }) => {
    const [isHovered, setIsHovered] = useState(false);
    const { values } = useFormikContext();
    const isRootLevel = !values.parentId;
    const chakraStyles = dropDownFormStyle(darkMode);

    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={stackStyling(true)}>
                <FormLabel sx={formLabelStyling(darkMode)}>Rule</FormLabel>
                <Field name="rule">
                    {({ field, form }) => {
                        const selected =
                            allOptions.find((o) => o.value === field.value) ||
                            NONE_RULE_OPTION;
                        return (
                            <Box
                                sx={{
                                    display: 'flex',
                                    width: '100%',
                                    alignItems: 'flex-start',
                                    paddingTop: '15px',
                                }}>
                                <VStack width="100%" alignItems="normal">
                                    <Select
                                        options={allOptions}
                                        value={selected}
                                        isDisabled={isRootLevel}
                                        onChange={(opt) =>
                                            form.setFieldValue(
                                                'rule',
                                                opt?.value || '',
                                            )
                                        }
                                        chakraStyles={chakraStyles}
                                        selectedOptionColor="brand"
                                        data-walkthroughid={
                                            walkthroughIds.createMode
                                                .ufRuleSelect
                                        }
                                    />
                                    <Text sx={descriptionStyling}>
                                        {isRootLevel
                                            ? "Root-level items don't have a rule."
                                            : 'Required = required with parent. Optional = optional add-on.'}
                                    </Text>
                                </VStack>
                            </Box>
                        );
                    }}
                </Field>
                {isHovered && (
                    <FieldToolTip
                        label="Required = required with parent (inherits status). Optional = optional add-on. Root-level offerings have no rule."
                        ariaLabel="catalog-rule-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default RuleField;
